import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ReportUserGenerated} from "../../../../core/model-store/models/report-user-generated";

@Component({
    selector: 'stamp-report',
    templateUrl: './stamp-report.component.html',
    styleUrls: ['./stamp-report.component.css'],
    standalone: false
})
export class StampReportComponent implements OnChanges {

  @Input() reportTemplate: ReportUserGenerated;
  @Input() extractedArtifacts: any;
  @Input() viewOptionsCheckboxValues: any;
  @Input() preview: boolean = false;
  @Input() numColumnsInReport = 5;

  isPromptsSelected() {
    return this.viewOptionsCheckboxValues.find((option) => option.key === 'vis_ledetekster')?.value;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('extractedArtifacts')) {
      console.log('_____****_______');
      console.log(this.extractedArtifacts);
    }
  }
}
